import axios from 'axios'
import { SALES_DASHBOARD , 
  // mutations 
  SET_ABO_INFO, 
  SET_ABO_CARD_LIST, 
  SET_ATTAINMENT, 
  SET_INIT_COMPLETED, 
  SET_EOS, 
  SET_EFFECT_FLAG, 
  SET_SHOW_EFFECT_FLAG,
  SET_MESSAGE_BOX,

  // getters 
  GET_ABO_INFO, 
  GET_ABO_CARD_LIST, 
  GET_ATTAINMENT,
  GET_EOS, 
  GET_INIT_COMPLETED,
  GET_EFFECT_FLAG,
  GET_SHOW_EFFECT_FLAG,
  GET_MESSAGES, 

  //actions 
  FETCH_ATTAINMENT_INFO, 
  FETCH_EFFECT_SAVE, 
} from '../actions/dashboard'

const state = {
  aboInfo: Object, // ABO 정보 
  aboCardList: Array, // 회원 목록 
  attainment: {year: '2023', month: '03', objective: {persent: 0, level: 0}, sop: {persent : 0, level: 0}}, // 목표 차트 정보             
  initComple: false, // 초기호 완료 여부 
  eos: true, // 서비스 종료 여부
  objective: { 
    members : 30 // 신규회원 달성 목표
    , sop : 7 // SOP 유지 달성 목표 
  }, 
  effect_flag: false, // effect 효과 유무 
  showEffect: false, // effect 출력 여부 
  messages: Object // 화면 출력 메세지 
}

const mutations = {
  // 회원정보 변경 
  [SET_ABO_INFO](state, data) {
    state.aboInfo = data;
  },
  // 목표달성 정보 변경 
  [SET_ATTAINMENT] (state, data) { 
    state.attainment = data;
  },
  // 화면 출력 상태 변경 
  [SET_INIT_COMPLETED] (state, data){ 
    state.initComple = data;
  }, 
  // 서비즈 종료 여부 변경 
  [SET_EOS] (state, data) { 
    state.eos = data;
  }, 
  // 화면 효과 처리 여부 변경 
  [SET_EFFECT_FLAG] (state, data){
    state.effect_flag = data;
  },
  // 회원 목록 정보 변경 
  [SET_ABO_CARD_LIST](state, data){
    state.aboCardList = data;
  },
  // 화면 효과 후처리 여부 변경 
  [SET_SHOW_EFFECT_FLAG](state, data){ 
    state.showEffect = data;
  },
  [SET_MESSAGE_BOX](state, data) { 
    state.messages= data
  }
}

const getters = {
  // ABO 정보 조회 
  [GET_ABO_INFO](state) {
    return state.aboInfo;
  },
  // 목표 달성 조회 
  [GET_ATTAINMENT](state){ 
    return state.attainment;
  },
  // 서비스 종료 여부 조회 
  [GET_EOS](state){ 
    return state.eos;
  },
  // ABO 목록 조회 
  [GET_ABO_CARD_LIST](state) {
    return state.aboCardList;
  },
  // 화면 출력 여부 조회 
  [GET_INIT_COMPLETED](state){ 
    return state.initComple;
  },
  // 화면 효과 처리 여부 조회 
  [GET_EFFECT_FLAG](state) { 
    return state.effect_flag;
  },
  // 화면 효과 후처리 여부 조회 
  [GET_SHOW_EFFECT_FLAG](state){ 
    return state.showEffect; 
  },
  // 메세지 BOX 조회 
  [GET_MESSAGES](state){ 
    return state.messages;
  }
}

const actions = {
  // ABO 목록 조회 
  async [FETCH_ATTAINMENT_INFO] ({dispatch, commit}, payload) {
    await axios.post(
      process.env.AWS_GATEWAY_URL_V2 + '/sales/dashboard',
      {
        month: payload.year + payload.month,
        abo_no: state.aboInfo.aboNo,
        type: 'abo'
      }).then(response => {
      if (response.status === 200) {
        if (response.data.archive.status != 200) {
          alert(response.data.archive.message);
          window.location.href = process.env.AMWAY_ROOT_URL
        } else { 
          commit(SET_EOS, (response.data.eos === 'Y')); // 마감완료 여부 
          
          
          commit(SET_MESSAGE_BOX, response.data.messages); //메세지 목록
          
          let attainmentCnt = 0; // 목표달성 조(Default 0) 지역변수
          let sopCnt = 0; // SOP 유지달성 조(Default 0) 지역변수
          let sopThreeMonthsCnt = 0; // SOP 3개월 유지달성 조(default 0) 지연변수 
          
          // abo 리스트를 가지고 ABO 목록 정보를 구성
          const aboCardList = response.data.abo.data.map(item => {  
            const sop_objective = (item.SOP_ATTAINMENT == 'Y');
            attainmentCnt += 1;
            sopCnt += (sop_objective ? 1 : 0);
            sopThreeMonthsCnt += (item.SOP_THREE_MONTH_ATTAINMENT == 'Y')

            return {'number': item.ORD_IMC_NO
              , 'name': item.ORD_IMC_NM
              , 'amt': (item.ORD_AMT === 100000 ? '10만원' : '20만원')
              , 'sop': {
                'SEP': item.SEP_SOP === 'Y',
                'OCT': item.OCT_SOP === 'Y',
                'NOV': item.NOV_SOP === 'Y'
              }
              , 'sop_objective': item.SOP_ATTAINMENT == 'Y'
            }
          });

          commit(SET_ABO_CARD_LIST, aboCardList); // ABO 목록 설정

          // 목표달성 데이터 구성 
          const attainment =  {
            year : payload.year, 
            month : payload.month, 
            objective : { 
              level : attainmentCnt // 목표달성 조 설정
              , persent : (attainmentCnt >= state.objective.members ? 100 : Math.round((attainmentCnt / state.objective.members) * 100)) // 목표달성 조 퍼센트
              , label : ['신규ABO', '프로모션 달성 조']
            }, 
            sop : { 
              level : sopCnt // 목표달성 조 설정
              , persent : (sopCnt >= state.objective.sop ? 100 : Math.round((sopCnt / state.objective.sop) * 100)) // SOP 유지 조 퍼센트
              , label : ['장스오']
            }
          }
          commit(SET_ATTAINMENT, attainment); // 목표달성 결과 

          /* 
          effect 효과를 받은 적이 없고 (받은적이 없으며 Y, 받은적이 있으면 N)
          objectvie(신규회원)의 목표가 달성하고 sop(장스오 3개월유지)의 목표를 도달한 경우 효과처리 
          */
          const showEffect = response.data.effect.data == 'Y' && (attainment.objective.persent == 100 && sopThreeMonthsCnt >= state.objective.sop);
          commit(SET_EFFECT_FLAG, showEffect); // 효과 적용 여부 

          commit(SET_INIT_COMPLETED, true); // 화면출력 시킴
        }
      } else {
        alert(this.messages.ERROR_DATA_FAULT)
      }
    }).catch(error => {
      alert(this.messages.ERROR_UNKWON)
    })
  },
  // Effect 효과 처리 저장 
  async [FETCH_EFFECT_SAVE] ({dispatch, commit}) {
    // effect 효과 처리 시, 효과처리 유무 저장 
    await axios.post(
      process.env.AWS_GATEWAY_URL_V2 + '/sales/dashboard-effect',
      {
        month: state.attainment.year + state.attainment.month,
        abo_no: state.aboInfo.aboNo
      }).then(response => {
        if (response.status === 200) {
          console.log('Amway Event LOG : Effect Off', response.data.statusMessage)
        } else {
          alert(state.messages.ERROR_DATA_FAULT);
        }
    }).catch(error => {
      alert(state.messages.ERROR_UNKWON);
    })
  }
}

export default {
    namespaced : true,
    state, 
    mutations,
    getters,
    actions
}
